import { Autocomplete, Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../Hooks";
import { AddLicForUserAdmin, SearchUserFio } from "../../../services/api-actions/user-action";
import { getSearchUserByFio } from "../../../store/user-process/selector";
import { useEffect, useId, useState } from "react";

export default function AdduserLic(){

  const colWidth = { xs: 12, sm: 4, md: 4, lg: 4 } as const;

  const dispatch = useAppDispatch();
  const [searchValue,setSearchValue] = useState("");
  const [selectUserInfo,setSelectUserInfo] = useState({
    userId:'',
    lic:'',
    fio:''
  });
  const searchUserRaw = useAppSelector(getSearchUserByFio);
  // сервер может вернуть не массив (например, страницу ошибки) — тогда показываем пустой список
  const searchUser = (Array.isArray(searchUserRaw) ? searchUserRaw : []).map((item)=> {
    return { label: item.email, fio: item.fio?.trim() ?? '', id: item.userId };
   });
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(SearchUserFio({fio:searchValue}));
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchValue]);

  return(
  <>
    <Grid container spacing={2}>
      <Grid item {...colWidth} >
        <Autocomplete
            disablePortal
            noOptionsText={'Ничего не найдено'}
            id="combo-box-demo"
            options={searchUser ?? []}
            filterOptions={(options) => options}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(props, option) => (
              <Box component="li" {...props} key={option.id} sx={{ flexDirection: "column", alignItems: "flex-start !important" }}>
                <Typography variant="body2">{option.label}</Typography>
                {option.fio && (
                  <Typography variant="caption" color="text.secondary">
                    {option.fio}
                  </Typography>
                )}
              </Box>
            )}
            onChange={(event, newValue) => {
              setSelectUserInfo({...selectUserInfo, userId:newValue?.id ?? '', fio:newValue?.label ?? ''})
            }}
            onInputChange={(event: object, value: any, reason: string)=>{
              // после выбора в поле подставляется email — повторный поиск не нужен
              if (reason === 'reset') return;
              setSearchValue(value);
            }}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Email пользователя" placeholder="Начните вводить email" />}
          />
      </Grid>
      <Grid item {...colWidth} >
        <TextField
          id="outlined-number"
          label=""
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          helperText={`Лицевой счет`}
          onChange={(e:any)=>{
            setSelectUserInfo({...selectUserInfo, lic:e.target.value})
          }}
        />
      </Grid>
      <Grid item {...colWidth} >
        <Button variant="contained" color="success" onClick={()=>{
          dispatch(AddLicForUserAdmin({UserId:selectUserInfo.userId,Lic:selectUserInfo.lic}));
        }}
        >
          Добавить
        </Button>
      </Grid>
    </Grid>
  </>
  );
}
